import Vue from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

Vue.filter('duration', (seconds: number, format = 'HH:mm') => dayjs.duration(seconds, 'second').format(format));
